import { m } from 'framer-motion';
// @mui
import { Container, Typography } from '@mui/material';
import { ForbiddenIllustration } from 'src/assets';
import { useUser } from 'src/backoffice-app-code/features/Auth/applications/hooks/useUser';
import { UserRole } from 'src/backoffice-app-code/features/Auth/models/User';
import { MotionContainer, varBounce } from 'src/components/animate';

// ----------------------------------------------------------------------

type RoleBasedGuardProp = {
  hasContent?: boolean;
  roles?: UserRole[];
  children: React.ReactNode;
};

export default function RoleBasedGuard({ hasContent, roles, children }: RoleBasedGuardProp) {
  const { user } = useUser();

  const currentRoles = user?.userRole;

  if (!roles) return <>{children}</>;
  if (currentRoles && roles.some((role) => currentRoles.includes(role))) return <>{children}</>;

  return hasContent ? (
    <Container component={MotionContainer} sx={{ textAlign: 'center' }}>
      <m.div variants={varBounce().in}>
        <Typography variant="h3" paragraph>
          Permission Denied
        </Typography>
      </m.div>

      <m.div variants={varBounce().in}>
        <Typography sx={{ color: 'text.secondary' }}>
          You do not have permission to access this page
        </Typography>
      </m.div>

      <m.div variants={varBounce().in}>
        <ForbiddenIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
      </m.div>
    </Container>
  ) : null;
}
